import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

axios.defaults.withCredentials = true;

const API_URL = 'https://whatsbotapi.zerwone.com';

export const Register = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();

    await axios
      .post(`${API_URL}/register`, { username, password })
      .then((response) => {
        console.log(response.data.message);
      })
      .catch((error) => {
        console.error(error);
        setErrorMessage(error.response.data.message);
      });

    if (username && password) {
      navigate("/login");
    } else {
      setErrorMessage("Please enter a username and password.");
    }

    navigate("/login");
  };

  return (
    <div className="max-w-sm mx-auto mt-10 p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md">
      <h2 className="text-3xl font-bold mb-6 text-gray-900 dark:text-gray-100">
        Register
      </h2>
      <p className="text-red-500 mb-6">{errorMessage}</p>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Username"
          className="w-full p-3 border border-gray-300 rounded-md dark:bg-gray-800 dark:border-gray-600 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400"
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className="w-full p-3 border border-gray-300 rounded-md dark:bg-gray-800 dark:border-gray-600 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400"
        />
        <button
          type="submit"
          className="w-full p-3 bg-green-500 text-white rounded-md hover:bg-green-600 dark:bg-green-600 dark:hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-400"
        >
          Register
        </button>
      </form>
      <p className="mt-6 text-center text-gray-700 dark:text-gray-300">
        Already have an account?{" "}
        <Link
          to="/login"
          className="text-blue-500 dark:text-blue-400 hover:underline"
        >
          Login
        </Link>
      </p>
    </div>
  );
};
